import Vue from "vue";
import DataTable from 'laravel-vue-datatable';

import ClientDataTable from "./components/ClientDataTable";
import ClientCreate from "./components/ClientCreate";
import ClientEdit from "./components/ClientEdit";
import AgreementCreate from "./components/AgreementCreate";
import AgreementEdit from "./components/AgreementEdit";
import ProductDataTable from "./components/ProductDataTable";
import ProductCreate from "./components/ProductCreate";
import ServiceCreate from "./components/ServiceCreate";
import InsuranceCreate from "./components/InsuranceCreate.vue";
import BookingCreate from "./components/BookingCreate";
import RecurringDataTable from "./components/RecurringDataTable";
import RecurringCreate from "./components/RecurringCreate";
import RecurringEdit from "./components/RecurringEdit";
import TripDataTable from "./components/TripDataTable";
import TripEdit from "./components/TripEdit";
import UserDataTable from "./components/UserDataTable";
import BookingDataTable from "./components/BookingDataTable";
import BookingEdit from "./components/BookingEdit";
import UserCreate from "./components/UserCreate";
import Settings from "./components/Settings";
import StepAddressCreate from "./components/StepAddressCreate";
import StepAddresses from "./components/StepAddresses";
import LocationDataTable from "./components/LocationDataTable";
import DriverDataTable from "./components/DriverDataTable";
import ColliDataTable from "./components/ColliDataTable";
import LocationEdit from "./components/LocationEdit";
import DriverEdit from "./components/DriverEdit";
import VehicleEdit from "./components/VehicleEdit";
import Plannings from "./components/Plannings";
import ReceiveGoods from "./components/ReceiveGoods";
import ReceiveColli from "./components/ReceiveColli";
import MoveGoods from "./components/MoveGoods";
import PackGoods from "./components/PackGoods";
import CreateBarcode from "./components/CreateBarcode";
import BookingRecalculatePrices from "./components/BookingRecalculatePrices";
import Route from "./components/Route";
import Rate from "./components/Rate";
import Invoices from "./components/Invoices";
import CheckDelivery from "./components/CheckDelivery";
import SmsTemplateDataTable from "./components/Sms/SmsTemplateDataTable.vue";
import SmsTemplate from "./components/Sms/SmsTemplate.vue";
import Configurations from "./components/Configurations.vue";
import ConfigurationsExternalDriverFees from "./components/ConfigurationsExternalDriverFees.vue";
import CockpitOverview from "./components/Cockpit/CockpitOverview.vue";
import CockpitConfiguration from "./components/Cockpit/CockpitConfiguration.vue";
import CmfStep1 from "./components/customer-mobile-flow/CmfStep1.vue";
import CmfStep2 from "./components/customer-mobile-flow/CmfStep2.vue";
import CmfStep3 from "./components/customer-mobile-flow/CmfStep3.vue";
import CmfStep4 from "./components/customer-mobile-flow/CmfStep4.vue";
import CmfStep5 from "./components/customer-mobile-flow/CmfStep5.vue";
import CmfStep7 from "./components/customer-mobile-flow/CmfStep7.vue";
import CmfFooter from "./components/customer-mobile-flow/CmfFooter.vue";
import CmfPickupStep1 from "./components/customer-mobile-flow/pickup/CmfPickupStep1.vue";
import CmfPickupStep2 from "./components/customer-mobile-flow/pickup/CmfPickupStep2.vue";
import CmfPickupStep3 from "./components/customer-mobile-flow/pickup/CmfPickupStep3.vue";
import CmfPickupStep4 from "./components/customer-mobile-flow/pickup/CmfPickupStep4.vue";
import CmfPickupStep6 from "./components/customer-mobile-flow/pickup/CmfPickupStep6.vue";
import CmfPaymentPage from "./components/customer-mobile-flow/CmfPaymentPage.vue";

import FlashMessage from '@smartweb/vue-flash-message';
import VueProgressBar from 'vue-progressbar'
import vSelect from "vue-select";
import ProgressBar from 'vuejs-progress-bar'
import DatePicker from 'vue2-datepicker';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import 'vue2-datepicker/index.css';
import {BootstrapVue} from 'bootstrap-vue'
import vTitle from 'vuejs-title'
import VueCountryCode from "vue-country-code";
import RoutesPlanning from "./components/RoutesPlanning.vue";
import Testpage from "./components/testpage/Testpage.vue";
import DriverFees from "./components/DriverFees.vue";
import Performance from "./components/performance/Performance.vue";
import CompanyNameCost from "./components/CompanyNameCost.vue"
import Permissions from "./components/Permissions.vue";

import AddOnCreate from "./components/add-on/AddOnCreate.vue";
import CustomServiceCreate from "./components/custom-service/CustomServiceCreate.vue";

require('./bootstrap');

Vue.use(BootstrapVue)
Vue.use(DatePicker)
Vue.use(VueTimepicker)
Vue.use(ProgressBar)
Vue.use(DataTable);
Vue.use(VueCountryCode);
Vue.use(FlashMessage, {});
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '20px'
})
Vue.use(vTitle, {
    cssClass: "my-title-bubble",
    fontSize: "14px",
    maxHeight: "150px",
    maxWidth: "380px"
})

Vue.component("v-select", vSelect);

Vue.directive('number', {
    inserted(el, binding, vnode) {
        var event = new Event("input", {bubbles: true});
        el.value = Number(el.value).toLocaleString('da-DK');
        el.dispatchEvent(event);
    },
});

Vue.directive('number_price', {
    inserted(el, binding, vnode) {
        var event = new Event("input", {bubbles: true});
        el.value = Number(el.value).toLocaleString('da-DK', {
                // minimumFractionDigits: 2, // Minimum number of decimal places
                maximumFractionDigits: 2  // Maximum number of decimal places
            }
        );
        el.dispatchEvent(event);
    },
});
const app = new Vue({
    el: '#app',
    components: {
        ClientDataTable,
        ProductDataTable,
        ClientCreate,
        ClientEdit,
        AgreementCreate,
        AgreementEdit,
        ProductCreate,
        ServiceCreate,
        InsuranceCreate,
        BookingCreate,
        UserDataTable,
        BookingDataTable,
        BookingEdit,
        RecurringDataTable,
        RecurringCreate,
        RecurringEdit,
        TripDataTable,
        TripEdit,
        UserCreate,
        Settings,
        StepAddresses,
        StepAddressCreate,
        LocationDataTable,
        DriverDataTable,
        Plannings,
        ColliDataTable,
        LocationEdit,
        DriverEdit,
        VehicleEdit,
        ReceiveGoods,
        ReceiveColli,
        CreateBarcode,
        MoveGoods,
        PackGoods,
        BookingRecalculatePrices,
        Route,
        Rate,
        CheckDelivery,
        Invoices,
        SmsTemplateDataTable,
        SmsTemplate,
        RoutesPlanning,
        Configurations,
        ConfigurationsExternalDriverFees,
        CockpitOverview,
        CockpitConfiguration,
        CmfStep1,
        CmfStep2,
        CmfStep3,
        CmfStep4,
        CmfStep5,
        CmfStep7,
        CmfFooter,
        CmfPickupStep1,
        CmfPickupStep2,
        CmfPickupStep3,
        CmfPickupStep4,
        CmfPickupStep6,
        CmfPaymentPage,
        Testpage,
        DriverFees,
        Performance,
        CompanyNameCost,
        Permissions,
        AddOnCreate,
        CustomServiceCreate
    }
});
